<template>
    <div style="width:100%">

        <div v-if="colmena===null && date_archived===null">
            <router-link v-bind:to="'/ciclo-reina-nueva/'+idqueen">
            ASIGNAR COLMENA
            </router-link>
        </div>

        <div v-if="date_archived!=null">
            <p>Fecha archivada: {{date_archived}}</p>
        </div>

        <div v-else>

            <div v-if="colmena!=null">
                <p>Colmena <b>{{ colmena }}</b> en <b>{{ colmenar }}</b></p>
            </div>
            <hr>
            <div v-if="cycle">
                <p class="vsm-header">ÚLTIMO CICLO REINA</p>

                <!--router-link v-bind:to="'/ciclos-reina/'+idqueen"-->
                <span v-if="date!=''" >{{ date }}</span>&nbsp;
                <span v-if="cycle" class="let">{{ cycle }}</span> <span v-if="state" class="let">, {{ state }}</span>
                <!--/router-link-->

            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: 'lastcyclequeen',
  props: ['idqueen','colmenar','colmena','date','cycle','state','color', 'date_archived'],
};
</script>